import React from "react";
import { Link } from "react-router-dom";
import { Plane, MapPin, Clock, Sparkles, Navigation, Camera, Crown } from "lucide-react";
import { SERVICES } from "../lib/api";

const ICONS = { Plane, MapPin, Clock, Sparkles, Navigation, Camera, Crown };
const DETAILS = {
  "airport-transfer": ["Real-time flight tracking — JFK, LGA, EWR & Westchester County (HPN)", "30 minutes complimentary waiting time — domestic flights", "45 minutes complimentary waiting time — international flights", "Westchester Airport service available between Westchester and NYC only · NJ service between New Jersey and NYC only"],
  "point-to-point": ["Door-to-door across NYC & surrounding areas", "Silent, sanitized cabin", "Additional stops: Fees may apply · Meet-and-Greet available — $15", "15-minute grace period; after that fees may apply"],
  "hourly": ["Hourly rate set by vehicle category — Sedan, SUV, or Van", "Two-hour minimum · your chauffeur on standby", "Tolls, parking, waiting time & additional stops charged separately — fees may apply", "Discreet, off-the-clock professionalism"],
  "special-event": ["Weddings, corporate events, celebrations, galas, parties, and more", "Detailed interiors & choreographed arrivals", "Multi-vehicle coordination available", "Red Carpet Service — additional cost upon request"],
  "long-distance": ["Extended journeys, out-of-area travel, special destinations, and more", "Custom quotes for every itinerary", "Cabin dining and rest planning on request", "Return trips fully coordinated"],
  "photoshoot": ["Luxury sedan as the default vehicle category", "2-hour minimum booking", "Flexible scheduling for editorial, brand campaigns, personal shoots, and more", "Special pricing — request a custom quote"],
  "limo": ["Weddings, Sweet 15s/16s, tours, celebrations, special events, and more", "Special pricing — inquiry required", "No fixed rate; every limo booking is a custom quote", "Professional chauffeur & detailed interior"],
};

export default function Services() {
  return (
    <div className="section-container py-16 sm:py-24">
      <div className="max-w-2xl">
        <div className="eyebrow mb-3">Our Services</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-white leading-tight">Every itinerary, considered.</h1>
        <p className="mt-6 text-slate-400 leading-relaxed">From a single airport transfer to multi-day corporate roadshows and choreographed wedding parties — we tailor the ride to the occasion.</p>
      </div>

      <div className="mt-14 space-y-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          const isEvent = s.id === "special-event";
          const isLD = s.id === "long-distance";
          const isPhoto = s.id === "photoshoot";
          const isLimo = s.id === "limo";
          const bookLink = isEvent ? "/contact?subject=event" : (isLD ? "/contact?subject=quote" : isPhoto ? "/contact?subject=photoshoot" : isLimo ? "/contact?subject=quote&vehicle=limo" : `/booking?service=${s.id}`);
          const cta = isEvent ? "Request Event Transportation" : (isLD ? "Request a Quote" : isPhoto ? "Request a Photoshoot Quote" : isLimo ? "Inquire for Special Pricing" : "Book This Service");
          return (
            <div key={s.id} className="lume-card p-8 flex flex-col md:flex-row gap-8" data-testid={`service-detail-${s.id}`}>
              <div className="md:w-1/3">
                <Icon className="text-[color:var(--lume-gold)]" size={28}/>
                <h2 className="font-serif text-2xl text-white mt-4">{s.title}</h2>
                <p className="text-sm text-slate-400 mt-3">{s.subtitle}</p>
                <Link to={bookLink} className="btn-outline-gold mt-6 inline-block" data-testid={`service-cta-${s.id}`}>{cta}</Link>
              </div>
              <div className="md:w-2/3">
                <div className="eyebrow mb-4">What's included</div>
                <ul className="space-y-3">
                  {DETAILS[s.id].map((d) => (
                    <li key={d} className="flex items-start gap-3 text-slate-300 text-sm">
                      <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--lume-gold)] mt-2"/>
                      <span>{d}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
